//console.log(process.env.NODE_ENV);
export default {
	api_url: (process.env.NODE_ENV==='production')? 'https://b2bapi.xbees.in/api/':'https://cargoautoallocation-apistage.xbees.in/api/',
	//  api_url: 'http://localhost:8081/api/',
	iptracker_url: (process.env.NODE_ENV==='production') ? 'https://track.xbees.in/api/':'https://stageiptracking.xbees.in/api/',
	app_url: (process.env.NODE_ENV==='production')? 'https://b2bapp.xbees.in/':'https://stage-cargoautoallocation-app.xbees.in/',
	// app_url: 'http://localhost:8086/',
	keycloakUrl: (process.env.NODE_ENV==='production') ? 'https://auth.xbees.in' : 'https://stage-auth.xbees.in',
	authclientid: (process.env.NODE_ENV==='production') ? 'b2bxpress-ui' : 'b2bxpress-ui',
	authclientidapi: (process.env.NODE_ENV==='production') ? 'b2bxpress-service' : 'b2bxpress-service'
}



// WEBPACK FOOTER //
// ./src/constants.js